import axios from "axios";
import store from "@/store";
import qs from "qs";
import { checkToken, decryptData } from "@/store/crypt";
import configs from "@/config/config";

const addErrorLog = (errorInfo) => {
	const {
		statusText,
		status,
		request: { responseURL },
	} = errorInfo;
	let info = {
		type: "ajax",
		code: status,
		mes: statusText,
		url: responseURL,
	};
	if (!responseURL.includes("save_error_logger"))
		store.dispatch("addErrorLog", info);
};

class HttpRequest {
	constructor(baseUrl) {
		this.baseUrl = baseUrl;
		this.queue = {};
	}
	getInsideConfig() {
		const config = {
			// baseURL: this.baseUrl,
			headers: {
				Accept: "application/json",
				"Content-Type": "application/x-www-form-urlencoded",
			},
		};
		// if (store.state.module.token) {
		// 	config.headers["Authorization"] = store.state.module.token;
		// }
		return config;
	}
	destroy(url) {
		delete this.queue[url];
		if (!Object.keys(this.queue).length) {
			// Spin.hide()
		}
	}
	interceptors(instance, url) {
		// 请求拦截
		instance.interceptors.request.use(
			(config) => {
				// 添加全局的loading...
				if (!Object.keys(this.queue).length) {
					// Spin.show() // 不建议开启，因为界面不友好
				}
				this.queue[url] = true;
				return config;
			},
			(error) => {
				return Promise.reject(error);
			}
		);
		// 响应拦截
		instance.interceptors.response.use(
			(res) => {
				this.destroy(url);
				if (parseInt(res.status) != 200) {
					this.$Message.error("网络错误");
					return;
				}
				if (res.data.cryptFlag == 1) {
					res.data.data = decryptData(res.data.data);
				}
				return res.data;
			},
			(error) => {
				this.destroy(url);
				let errorInfo = error.response;
				if (!errorInfo) {
					const {
						request: { statusText, status },
						config,
					} = JSON.parse(JSON.stringify(error));
					errorInfo = {
						statusText,
						status,
						request: { responseURL: config.url },
					};
				}
				addErrorLog(errorInfo);
				return Promise.reject(error);
			}
		);
	}
	request(options) {
		const instance = axios.create();
		if (configs.cryptFlag == 1) {
			if (options.method === "post") {
				options.data = qs.stringify(checkToken(options.data));
			} else {
				options.params = checkToken(options.params);
			}
		} else {
			if (options.method === "post") {
				options.data["cid"] = configs.channelID;
				options.data["sourceFlag"] = configs.sourceFlag;
				options.data["timestamp"] = Date.parse(new Date()) / 1000;
				options.data["siteCode"] = configs.websiteTemplateCode;
				options.data = qs.stringify(options.data);
			} else {
				options.params["cid"] = configs.channelID;
				options.params["sourceFlag"] = configs.sourceFlag;
				options.params["timestamp"] = Date.parse(new Date()) / 1000;
				options.params["siteCode"] = configs.websiteTemplateCode;
			}
		}
		options = Object.assign(this.getInsideConfig(), options);
		options.url = this.baseUrl + options.url;
		// console.log("axios options", options);
		this.interceptors(instance, options.url);
		return instance(options);
	}

	apiRequest(data, url, method) {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve(
					this.request({
						url: url,
						data,
						method: method,
					})
				);
				reject({ code: 2, msg: "请求错误,请重新操作" });
			}, 1000);
		})
			.then((res) => {
				return res;
			})
			.catch((err) => {
				return { code: -1, msg: "网络超时,请重新操作" };
			});
	}
}
export default HttpRequest;
